import { render } from "./Button.vue?vue&type=template&id=1b0fb126"
const script = {}
script.render = render

export default script